// extracted by mini-css-extract-plugin
module.exports = {"textareaResize":"contact_textareaResize__oLgfQ","checkboxAccent":"contact_checkboxAccent__33dwF","inputFocus":"contact_inputFocus__mVHJW","s2Open":"contact_s2Open___xZID"};